"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exceptionsMap = void 0;
var exceptions = [
    'guru.wildberries.ru',
    'digital.wildberries.ru',
    'suppliers-credits-request-stage.wildberries.ru',
    'suppliers-credits-requests.wildberries.ru',
    'vmeste.wildberries.ru',
    'pro.wildberries.ru',
    'tablo.wb.ru',
];
exports.exceptionsMap = exceptions.reduce(function (acc, item) {
    acc[item] = item;
    return acc;
}, {});
